/**
 * ONE GROUP OF THEIR FILTER CHIPS — a heading and a row of toggles.
 *
 * 🔴 IT LIVES HERE RATHER THAN ON THE EXERCISES PAGE BECAUSE W32(3) GAVE IT A SECOND CALLER:
 * the workout builder's rail opens the same equipment/category chips in a popover. Copying the
 * twelve lines would have been two controls that agree today and are one edit from disagreeing
 * about the thing below that is easiest to get wrong — what a SECOND press does.
 *
 * ⚠️ **REAL `<button>`s WITH `aria-pressed`, NEVER `div`s WITH A CLICK.** §12 measured their own
 * filter panel's controls as unreachable from a keyboard; copying the LOOK of a chip is not a
 * licence to copy that, and `aria-pressed` is what tells a screen reader which chips are on.
 *
 * ⚠️ **A SECOND PRESS CLEARS.** There is no `Any` chip, because their panel has none and because
 * a group where nothing is pressed already means "any" — an extra chip for the absence of a
 * choice is a control that says what the other chips' state already says.
 */
export function ChipGroup({ heading, options, current, onPick }: {
  heading: string;
  options: readonly { readonly value: string; readonly label: string }[];
  current: string | null;
  onPick: (value: string | null) => void;
}) {
  const id = `chips-${heading.toLowerCase().replace(/[^a-z]+/g, "-")}`;
  return (
    <div className="exercises-chipgroup" role="group" aria-labelledby={id}>
      <p className="ht-overline exercises-chipgroup-head" id={id}>{heading}</p>
      <div className="exercises-chiprow">
        {options.map((o) => (
          <button key={o.value} type="button"
                  className={current === o.value ? "exercises-chip is-on" : "exercises-chip"}
                  aria-pressed={current === o.value}
                  onClick={() => { onPick(current === o.value ? null : o.value); }}>
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
